import { createSlice } from "@reduxjs/toolkit";

export const aclSlice = createSlice({
  name: "acl",
  initialState: {
    data: [],
  },
  reducers: {
    updateACL: (state, data) => {
      state.data = data.payload;
    },
  },
});

export const { updateACL } = aclSlice.actions;

export default aclSlice.reducer;
